import React from 'react';
import { Link } from 'react-router-dom';
import { PackageIcon, ShoppingCartIcon, UsersIcon, DollarSignIcon, TrendingUpIcon, TrendingDownIcon, BoxIcon, TruckIcon, TagIcon, BarChart3Icon, SettingsIcon, BellIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { formatPrice } from '../../utils/formatters';
const stats = [{
  label: 'Total Revenue',
  value: formatPrice(2450000),
  change: '+12.5%',
  trend: 'up',
  icon: DollarSignIcon,
  color: 'bg-green-100 text-green-600'
}, {
  label: 'Total Orders',
  value: '1,234',
  change: '+8.2%',
  trend: 'up',
  icon: ShoppingCartIcon,
  color: 'bg-blue-100 text-blue-600'
}, {
  label: 'Total Products',
  value: '456',
  change: '+3.1%',
  trend: 'up',
  icon: PackageIcon,
  color: 'bg-purple-100 text-purple-600'
}, {
  label: 'Total Customers',
  value: '8,901',
  change: '+15.3%',
  trend: 'up',
  icon: UsersIcon,
  color: 'bg-orange-100 text-orange-600'
}];
const recentOrders = [{
  id: 'GZ-001234',
  customer: 'Ahmed Khan',
  amount: 45999,
  status: 'delivered',
  date: '2024-01-20'
}, {
  id: 'GZ-001235',
  customer: 'Sara Ahmed',
  amount: 12999,
  status: 'shipped',
  date: '2024-01-20'
}, {
  id: 'GZ-001236',
  customer: 'Ali Hassan',
  amount: 67999,
  status: 'processing',
  date: '2024-01-19'
}, {
  id: 'GZ-001237',
  customer: 'Fatima Khan',
  amount: 8999,
  status: 'pending',
  date: '2024-01-19'
}, {
  id: 'GZ-001238',
  customer: 'Usman Ali',
  amount: 24999,
  status: 'delivered',
  date: '2024-01-18'
}];
const statusColors: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-700',
  processing: 'bg-blue-100 text-blue-700',
  shipped: 'bg-purple-100 text-purple-700',
  delivered: 'bg-green-100 text-green-700',
  cancelled: 'bg-red-100 text-red-700'
};
const menuItems = [{
  icon: BarChart3Icon,
  label: 'Dashboard',
  href: '/admin',
  active: true
}, {
  icon: PackageIcon,
  label: 'Products',
  href: '/admin/products'
}, {
  icon: ShoppingCartIcon,
  label: 'Orders',
  href: '/admin/orders'
}, {
  icon: UsersIcon,
  label: 'Customers',
  href: '/admin/customers'
}, {
  icon: BoxIcon,
  label: 'Inventory',
  href: '/admin/inventory'
}, {
  icon: TruckIcon,
  label: 'Shipping',
  href: '/admin/shipping'
}, {
  icon: TagIcon,
  label: 'Coupons',
  href: '/admin/coupons'
}, {
  icon: SettingsIcon,
  label: 'Settings',
  href: '/admin/settings'
}];
export function AdminDashboard() {
  return <div className="min-h-screen bg-gray-100" data-id="element-989">
      {/* Admin header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40" data-id="element-990">
        <div className="flex items-center justify-between px-6 py-4" data-id="element-991">
          <div className="flex items-center gap-4" data-id="element-992">
            <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-10 w-auto object-contain" data-id="element-993" />
            <div data-id="element-994">
              <h1 className="text-lg font-bold text-gray-900" data-id="element-995">Gadgets Zone</h1>
              <p className="text-xs text-gray-500" data-id="element-996">Admin Dashboard</p>
            </div>
          </div>
          <div className="flex items-center gap-4" data-id="element-997">
            <button className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg" data-id="element-998">
              <BellIcon className="w-5 h-5" data-id="element-999" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" data-id="element-1000" />
            </button>
            <div className="flex items-center gap-3" data-id="element-1001">
              <div className="w-9 h-9 bg-primary-100 rounded-full flex items-center justify-center" data-id="element-1002">
                <span className="text-primary-600 font-medium" data-id="element-1003">A</span>
              </div>
              <div className="hidden sm:block" data-id="element-1004">
                <p className="text-sm font-medium text-gray-900" data-id="element-1005">Admin</p>
                <p className="text-xs text-gray-500" data-id="element-1006">admin@gadgetszone.pk</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="flex" data-id="element-1007">
        {/* Sidebar */}
        <aside className="w-64 bg-white border-r border-gray-200 min-h-[calc(100vh-73px)] hidden lg:block" data-id="element-1008">
          <nav className="p-4 space-y-1" data-id="element-1009">
            {menuItems.map(item => <Link key={item.label} to={item.href} className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${item.active ? 'bg-primary-50 text-primary-600' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1010">
                <item.icon className="w-5 h-5" data-id="element-1011" />
                <span className="font-medium" data-id="element-1012">{item.label}</span>
              </Link>)}
          </nav>
        </aside>

        {/* Main content */}
        <main className="flex-1 p-6" data-id="element-1013">
          {/* Page header */}
          <div className="flex items-center justify-between mb-6" data-id="element-1014">
            <div data-id="element-1015">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-1016">Dashboard</h2>
              <p className="text-gray-500" data-id="element-1017">
                Welcome back! Here's what's happening today.
              </p>
            </div>
            <div className="flex gap-3" data-id="element-1018">
              <Button variant="outline" data-id="element-1019">Export Report</Button>
              <Button variant="primary" data-id="element-1020">Add Product</Button>
            </div>
          </div>

          {/* Stats grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1021">
            {stats.map(stat => <Card key={stat.label} padding="lg" data-id="element-1022">
                <div className="flex items-start justify-between" data-id="element-1023">
                  <div data-id="element-1024">
                    <p className="text-sm text-gray-500" data-id="element-1025">{stat.label}</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-1026">
                      {stat.value}
                    </p>
                    <div className="flex items-center gap-1 mt-2" data-id="element-1027">
                      {stat.trend === 'up' ? <TrendingUpIcon className="w-4 h-4 text-green-500" data-id="element-1028" /> : <TrendingDownIcon className="w-4 h-4 text-red-500" data-id="element-1029" />}
                      <span className={stat.trend === 'up' ? 'text-green-600' : 'text-red-600'} data-id="element-1030">
                        {stat.change}
                      </span>
                      <span className="text-gray-400 text-sm" data-id="element-1031">
                        vs last month
                      </span>
                    </div>
                  </div>
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${stat.color}`} data-id="element-1032">
                    <stat.icon className="w-6 h-6" data-id="element-1033" />
                  </div>
                </div>
              </Card>)}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1034">
            {/* Recent orders */}
            <div className="lg:col-span-2" data-id="element-1035">
              <Card padding="none" data-id="element-1036">
                <div className="p-4 border-b border-gray-100 flex items-center justify-between" data-id="element-1037">
                  <h3 className="font-semibold text-gray-900" data-id="element-1038">Recent Orders</h3>
                  <Link to="/admin/orders" className="text-primary-600 hover:text-primary-700 text-sm font-medium" data-id="element-1039">
                    View All
                  </Link>
                </div>
                <div className="overflow-x-auto" data-id="element-1040">
                  <table className="w-full" data-id="element-1041">
                    <thead className="bg-gray-50" data-id="element-1042">
                      <tr data-id="element-1043">
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1044">
                          Order ID
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1045">
                          Customer
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1046">
                          Amount
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1047">
                          Status
                        </th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase" data-id="element-1048">
                          Date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100" data-id="element-1049">
                      {recentOrders.map(order => <tr key={order.id} className="hover:bg-gray-50" data-id="element-1050">
                          <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-1051">
                            {order.id}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-600" data-id="element-1052">
                            {order.customer}
                          </td>
                          <td className="px-4 py-3 text-sm font-medium text-gray-900" data-id="element-1053">
                            {formatPrice(order.amount)}
                          </td>
                          <td className="px-4 py-3" data-id="element-1054">
                            <span className={`px-2 py-1 text-xs font-medium rounded-full capitalize ${statusColors[order.status]}`} data-id="element-1055">
                              {order.status}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-500" data-id="element-1056">
                            {order.date}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>

            {/* Quick actions & alerts */}
            <div className="space-y-6" data-id="element-1057">
              <Card padding="lg" data-id="element-1058">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-1059">
                  Quick Actions
                </h3>
                <div className="space-y-3" data-id="element-1060">
                  <Button variant="outline" fullWidth className="justify-start" data-id="element-1061">
                    <PackageIcon className="w-4 h-4 mr-2" data-id="element-1062" />
                    Add New Product
                  </Button>
                  <Button variant="outline" fullWidth className="justify-start" data-id="element-1063">
                    <TagIcon className="w-4 h-4 mr-2" data-id="element-1064" />
                    Create Coupon
                  </Button>
                  <Button variant="outline" fullWidth className="justify-start" data-id="element-1065">
                    <TruckIcon className="w-4 h-4 mr-2" data-id="element-1066" />
                    Update Shipping
                  </Button>
                </div>
              </Card>

              <Card padding="lg" data-id="element-1067">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-1068">Alerts</h3>
                <div className="space-y-3" data-id="element-1069">
                  <div className="flex items-start gap-3 p-3 bg-yellow-50 rounded-lg" data-id="element-1070">
                    <BoxIcon className="w-5 h-5 text-yellow-600 flex-shrink-0" data-id="element-1071" />
                    <div data-id="element-1072">
                      <p className="text-sm font-medium text-yellow-800" data-id="element-1073">
                        Low Stock Alert
                      </p>
                      <p className="text-xs text-yellow-600" data-id="element-1074">
                        5 products are running low
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg" data-id="element-1075">
                    <ShoppingCartIcon className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-1076" />
                    <div data-id="element-1077">
                      <p className="text-sm font-medium text-blue-800" data-id="element-1078">
                        New Orders
                      </p>
                      <p className="text-xs text-blue-600" data-id="element-1079">
                        12 orders pending review
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </main>
      </div>
    </div>;
}